import { useEffect, useState } from "react";
import { usePrefersReducedMotion } from "../../../hooks/usePrefersReducedMotion";

const PHRASES = [
  "Questionário que vira perfil — e perfil que muda a interface.",
  "Conteúdo base único; apresentação e ritmo no seu formato.",
  "Regras claras primeiro; IA como assistente, não como decisor solto.",
  "Estudo e gamificação separados da nota formal.",
];

const INTERVAL_MS = 4200;

export function HeroRotatingTagline() {
  const reducedMotion = usePrefersReducedMotion();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (reducedMotion) return;
    const id = window.setInterval(() => {
      setIndex((i) => (i + 1) % PHRASES.length);
    }, INTERVAL_MS);
    return () => window.clearInterval(id);
  }, [reducedMotion]);

  if (reducedMotion) {
    return (
      <p className="mt-3 min-h-[1.75rem] text-pretty text-base font-medium text-teal-200/90 sm:text-lg">{PHRASES[0]}</p>
    );
  }

  return (
    <p className="mt-3 min-h-[1.75rem] text-pretty text-base font-medium text-teal-200/90 sm:text-lg" aria-live="polite">
      <span key={index} className="landing-hero-tagline-phrase">
        {PHRASES[index]}
      </span>
    </p>
  );
}
